import { WSPanel } from "@wingspanhq/fe-component-library";
import {
  BackgroundCheckConfiguration,
  BackgroundCheckConfigurationsApiCreateBackgroundCheckConfigurationRequest
} from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";

import { CreateBackgroundChecksPartialForm } from "../../../../modules/BackgroundChecks/createRequirementDefinition/CreateBackgroundChecksPartialForm";
import { RequirementDefinitionStandardBackgroundCheckFormValues } from "../../../../types";
import { getBaseEditValues } from "../../../../utils/getBaseEditValues";
import { RequirementDefinitionTemplateForm } from "../../types";

export const STANDARD_BACKGROUND_CHECK_FORM: RequirementDefinitionTemplateForm<
  BackgroundCheckConfiguration,
  RequirementDefinitionStandardBackgroundCheckFormValues,
  BackgroundCheckConfigurationsApiCreateBackgroundCheckConfigurationRequest
> = {
  getDefaultSettingsValues: template => ({
    instructions: "",
    package: ""
  }),
  getEditSettingsValues(template, requirementDefinition, settings) {
    return {
      instructions: settings.instructions ?? "",
      package: settings.packageId ?? ""
    };
  },
  mapDataSourceResponseToRequirementCreateRequest(response) {
    return {
      dataSourceId: response.id!
    };
  },
  mapFormDataToDataSourceCreateRequest(values) {
    return {
      backgroundCheckConfigurationCreate: {
        instructions: values.instructions,
        packageId: values.package,
        title: values.name
      }
    };
  },
  partialForm: (
    <WSPanel>
      <CreateBackgroundChecksPartialForm />
    </WSPanel>
  ),
  successCreationMessage: "Requirement created successfully",
  validationSchema: Yup.object().shape({
    instructions: Yup.string(),
    package: Yup.string().required("Required")
  })
};
